import { Text } from "@medusajs/ui"
import { getProductPrice } from "@/lib/util/get-product-price"
import { HttpTypes } from "@medusajs/types"

export default function ProductPrice({
  product,
}: {
  product: HttpTypes.StoreProduct
}) {
  const { cheapestPrice } = getProductPrice({
    product,
  })

  if (!cheapestPrice || cheapestPrice.calculated_price_number === null) {
    return (
      <div className="relative">
        <p className="font-sans txt-medium font-bold text-2xl text-navy">
          Zahtevaj ponudbo za ceno
        </p>
      </div>
    )
  }

  const isOnSale = cheapestPrice.price_type === "sale"

  return (
    <div className="flex flex-col gap-2">
      <div className="flex flex-wrap items-baseline gap-x-3 gap-y-2">
        {isOnSale && (
          <span
            className="inline-flex shrink-0 items-center rounded px-2.5 py-1 text-xs font-bold uppercase tracking-wide bg-yellow-400 text-navy shadow-sm"
            data-testid="product-sale-badge"
          >
            AKCIJA
          </span>
        )}
        <div className="relative">
          <Text
            className="font-bold text-3xl md:text-4xl text-navy"
            data-testid="product-price"
            data-value={cheapestPrice.calculated_price_number}
          >
            {cheapestPrice.calculated_price}
          </Text>
        </div>
      </div>

      {isOnSale && (
        <div className="flex flex-wrap items-baseline gap-x-3 gap-y-1">
          <Text className="line-through text-lg font-medium text-red-600/90">
            {cheapestPrice.original_price}
          </Text>
          <Text className="text-base font-semibold text-red-600">
            Prihranite {cheapestPrice.percentage_diff}%
          </Text>
        </div>
      )}

      {/* Subtle price type label */}
      <div className="flex flex-col gap-0.5">
        {isOnSale && (
          <Text className="text-xs text-neutral-500 font-medium">
            Omejena časovna ponudba
          </Text>
        )}
        <Text className="text-xs text-neutral-500 font-medium">
          Cena z DDV
        </Text>
      </div>
    </div>
  )
}
